export const CompanyTab = ({ state, errors, handleInputChange, handleCheckboxChange, handleTabChange }) => {
    return (
        <div className="tab-pane fade show active">
            <div className="row">
                <div className="col-md-6">
                    <div className="form-group mb-3">
                        <label>Company Name *</label>
                        <input
                            type="text"
                            className={`form-control ${errors.company_name ? 'is-invalid' : ''}`}
                            placeholder="Enter company name"
                            name="company_name"
                            value={state.company_name}
                            onChange={handleInputChange}
                            required
                        />
                        {errors.company_name && <div className="invalid-feedback">{errors.company_name}</div>}
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-group mb-3">
                        <label>Company Email *</label>
                        <input
                            type="email"
                            className={`form-control ${errors.company_email ? 'is-invalid' : ''}`}
                            placeholder="Enter company email"
                            name="company_email"
                            value={state.company_email}
                            onChange={handleInputChange}
                            required
                        />
                        {errors.company_email && <div className="invalid-feedback">{errors.company_email}</div>}
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-md-4">
                    <div className="form-group mb-3">
                        <label>Telephone *</label>
                        <input
                            type="number"
                            className={`form-control ${errors.telephone ? 'is-invalid' : ''}`}
                            placeholder="Enter telephone"
                            name="telephone"
                            value={state.telephone}
                            onChange={handleInputChange}
                        />
                        {errors.telephone && <div className="invalid-feedback">{errors.telephone}</div>}

                    </div>
                </div>
                <div className="col-md-4">
                    <div className="form-group mb-3">
                        <label>Fax</label>
                        <input
                            type="text"
                            className={`form-control`}
                            placeholder="Enter fax"
                            name="fax"
                            value={state.fax}
                            onChange={handleInputChange}
                        />
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="form-group mb-3">
                        <label>Mobile Number *</label>
                        <input
                            type="number"
                            className={`form-control ${errors.mobile_number ? 'is-invalid' : ''}`}
                            placeholder="Enter mobile number"
                            name="mobile_number"
                            value={state.mobile_number}
                            onChange={handleInputChange}
                            required
                        />
                        {errors.mobile_number && <div className="invalid-feedback">{errors.mobile_number}</div>}
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-md-6">
                    <div className="form-group mb-3">
                        <label>Establishment Date *</label>
                        <input
                            type="date"
                            className={`form-control ${errors.date ? 'is-invalid' : ''}`}
                            name="date"
                            value={state.date}
                            onChange={handleInputChange}
                            required
                        />
                        {errors.date && <div className="invalid-feedback">{errors.date}</div>}
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-group mb-3">
                        <label>Annual Turnover *</label>
                        <input
                            type="number"
                            className={`form-control ${errors.annual_turnover ? 'is-invalid' : ''}`}
                            placeholder="Enter annual turnover"
                            name="annual_turnover"
                            value={state.annual_turnover}
                            onChange={handleInputChange}
                            required
                        />
                        {errors.annual_turnover && <div className="invalid-feedback">{errors.annual_turnover}</div>}
                    </div>
                </div>
            </div>


            <div className="row">
                <div className="col-md-12">
                    <div className="form-group mb-3">
                        <label>Company Address *</label>
                        <textarea
                            className={`form-control ${errors.company_address ? 'is-invalid' : ''}`}
                            placeholder="Enter company address"
                            rows="3"
                            name="company_address"
                            value={state.company_address}
                            onChange={handleInputChange}
                            required
                        ></textarea>
                        {errors.company_address && <div className="invalid-feedback">{errors.company_address}</div>}
                    </div>
                </div>
            </div>

            <div className="form-group mb-3">
                <label>Dealing Type *</label>
                {errors.dealing_type && <div className="text-danger small mb-2">{errors.dealing_type}</div>}
                <div className="d-flex">
                    <div className="form-check mr-3">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            name="dealing_type"
                            value="0"
                            checked={state.dealing_type === 0}
                            onChange={handleCheckboxChange}
                        />
                        <label className="form-check-label ml-1">Corporate</label>
                    </div>
                    <div className="form-check mr-3">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            name="dealing_type"
                            value="1"
                            checked={state.dealing_type === 1}
                            onChange={handleCheckboxChange}
                        />
                        <label className="form-check-label ml-1">Partnership</label>
                    </div>
                    <div className="form-check mr-3">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            name="dealing_type"
                            value="2"
                            checked={state.dealing_type === 2}
                            onChange={handleCheckboxChange}
                        />
                        <label className="form-check-label ml-1">Sole Propritorship</label>
                    </div>
                </div>
            </div>

            <div className="d-flex justify-content-end align-items-start gap-3 mt-4">
                <button
                    type="button"
                    className="btn btn-info ms-auto btn-sm"
                    onClick={() => handleTabChange("owner")}
                >
                    Next
                </button>
            </div>
        </div>
    );
};